module.exports = __webpack_public_path__ + "static/media/Capa-WB43Free.ca8a0f79.PNG";